var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28316",
    "data-name": "Rectangle 28316",
    width: 60.113,
    height: 64.121,
    fill: "none",
    stroke: "#f24e59",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificados",
    transform: "translate(-303 -493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86386",
    "data-name": "Path 86386",
    d: "M50,0c50,0,50,0,50,50s0,50-50,50S0,100,0,50,0,0,50,0Z",
    transform: "translate(303 493)",
    fill: "#fde4e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg-icone-certificados",
    transform: "translate(322.943 510.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86349",
    "data-name": "Path 86349",
    d: "M34,27l0,12.774,5.141-5.062,5.141,5.141L44.28,27",
    transform: "translate(8.9 7.705)",
    fill: "#f24e59",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68391",
    "data-name": "Group 68391",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68390",
    "data-name": "Group 68390",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86350",
    "data-name": "Path 86350",
    d: "M39.6,11.427a1.309,1.309,0,0,1,1.934,0l1.559,1.67a3.566,3.566,0,0,0,2.384.987l2.285-.078a1.308,1.308,0,0,1,1.368,1.368l-.077,2.284a3.556,3.556,0,0,0,.986,2.384l1.67,1.56a1.31,1.31,0,0,1,0,1.934L50.04,25.1a3.556,3.556,0,0,0-.986,2.383l.077,2.283a1.309,1.309,0,0,1-1.368,1.369l-2.285-.077a3.56,3.56,0,0,0-2.384.987L41.535,33.71a1.309,1.309,0,0,1-1.934,0l-1.559-1.667a3.563,3.563,0,0,0-2.383-.987l-2.284.077a1.311,1.311,0,0,1-1.369-1.369l.077-2.283A3.557,3.557,0,0,0,31.1,25.1l-1.668-1.56a1.309,1.309,0,0,1,0-1.934l1.668-1.56a3.558,3.558,0,0,0,.987-2.384l-.077-2.284a1.309,1.309,0,0,1,1.369-1.368l2.284.078a3.563,3.563,0,0,0,2.383-.987Z",
    transform: "translate(7.474 3.139)",
    fill: "#f24e59",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1074",
    "data-name": "Ellipse 1074",
    cx: 4.008,
    cy: 3.006,
    rx: 4.008,
    ry: 3.006,
    transform: "translate(44.083 22.041)",
    fill: "#f24e59",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86351",
    "data-name": "Path 86351",
    d: "M7.427,62.7H48.558a6.427,6.427,0,0,0,6.427-6.427V53.7H13.854V56.27A6.427,6.427,0,1,1,1,56.27V1H48.558V8.712",
    transform: "translate(-0.516 0.285)",
    fill: "none",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3005",
    "data-name": "Line 3005",
    x2: 20.038,
    transform: "translate(12.023 14.026)",
    fill: "none",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3006",
    "data-name": "Line 3006",
    x2: 12.023,
    transform: "translate(12.023 22.041)",
    fill: "none",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3007",
    "data-name": "Line 3007",
    x2: 12.023,
    transform: "translate(12.023 32.06)",
    fill: "none",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3008",
    "data-name": "Line 3008",
    x2: 20.038,
    transform: "translate(12.023 42.079)",
    fill: "none",
    stroke: "#f24e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_86393",
    "data-name": "Path 86393",
    d: "M21.5,74.459H16.717v4.194L15.982,79.9l-1.324,2.059s-2.06.958-1.913,1.178,39.8.368,39.8.368l2.5-1.1,1.766-1.544.883-2.576V74.459Z",
    transform: "translate(-3.482 -20.354)",
    fill: "#f24e59"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificados);
export default __webpack_public_path__ + "static/media/certificados.19c59c6e1f08b9b262a2d2142032e164.svg";
export { ForwardRef as ReactComponent };